<template>
  <div class="base-switch">
    <div class="base-switch__list">
      <div
        v-for="(option, index) in options"
        :key="index"
        class="base-switch__item"
        :class="{
          'is-active': option === value,
          'is-male': option === 'M',
          'is-female': option === 'F',
        }"
        @click="handleChange(option)"
      >
        <div class="base-switch__control">
          <span
            v-if="option === 'M'"
            class="base-switch__label"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 10C11 7.23801 8.761 5 6 5C3.239 5 1 7.23801 1 10C1 12.761 3.239 15.0001 6 15.0001C8.761 15.0001 11 12.761 11 10Z"
                stroke="#1A5DD0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15 1L10 6.00003"
                stroke="#1A5DD0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11 1H15V5.00002"
                stroke="#1A5DD0"
                stroke-width="2"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span
            v-if="option === 'F'"
            class="base-switch__label"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 6C5 8.761 7.239 11 10 11C12.762 11 15 8.761 15 6C15 3.238 12.762 1 10 1C7.239 1 5 3.238 5 6Z"
                stroke="#BA5BD3"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 15L6 10"
                stroke="#BA5BD3"
                stroke-width="2"
                stroke-linejoin="round"
              />
              <path
                d="M1 11L5 15"
                stroke="#BA5BD3"
                stroke-width="2"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSwitch from './BaseSwitch.vue'

export default {
  name: 'GenderSwitch',
  extends: BaseSwitch,
  methods: {
    handleChange(val) {
      let value = val

      if (this.value === val) {
        value = ''
      }

      this.$emit('input', value)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.base-switch__item {
  transition: 200ms ease-in-out;
  background-color: $ui-kit-bg-gray-0;
}

.base-switch__item svg {
  opacity: 0.5;
  transition: 200ms ease-in-out;
}

.base-switch__item.is-active svg {
  opacity: 1;
}

.base-switch__item.is-active.is-male {
  background: #F7FAFC;
  border-color: #1A5DD0;
}

.base-switch__item.is-active.is-female {
  background: #F0E4F5;
  border-color: #BA5BD3;
}
</style>
